
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Vendor/WordPress/Jetpack Blocks" mdxType="Meta" />
    <h1>{`Jetpack Blocks`}</h1>
    <p>{`WordPress developer Automattic provides a `}<a parentName="p" {...{
        "href": "https://jetpack.com/"
      }}>{`Jetpack`}</a>{` plugin that includes additional blocks. We support a selection of these.`}</p>
    <h2>{`Markdown Block`}</h2>
    <p>{`The markdown block applies vertical rhythm between its children. If contained within a `}<a parentName="p" {...{
        "href": "/docs/objects-rhythm--default-story"
      }}>{`Rhythm object`}</a>{`, the markdown block will inherit the same spacing. For example, if the Rhythm object uses the `}<inlineCode parentName="p">{`o-rhythm--generous`}</inlineCode>{` modifier, the markdown block will inherit the generous spacing.`}</p>
    <p>{`See also: `}<a parentName="p" {...{
        "href": "https://jetpack.com/support/markdown/"
      }}>{`Markdown Block documentation`}</a></p>
    <Canvas mdxType="Canvas">
  <Story name="Markdown" mdxType="Story">
    {`<div class="wp-block-jetpack-markdown">
      <p>
        <b>Lorem</b> <i>ipsum</i> dolor sit amet, consectetur adipiscing elit. Quisque eu ex
        enim. Nunc efficitur scelerisque dolor et sollicitudin.
      </p>
      <p>
        Donec finibus lorem elit, eu consectetur quam pellentesque sed.
        Pellentesque habitant morbi tristique senectus et netus et malesuada
        fames ac turpis egestas.
      </p>
    </div>`}
  </Story>
    </Canvas>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const markdown = () => (
          `<div class="wp-block-jetpack-markdown">
      <p>
        <b>Lorem</b> <i>ipsum</i> dolor sit amet, consectetur adipiscing elit. Quisque eu ex
        enim. Nunc efficitur scelerisque dolor et sollicitudin.
      </p>
      <p>
        Donec finibus lorem elit, eu consectetur quam pellentesque sed.
        Pellentesque habitant morbi tristique senectus et netus et malesuada
        fames ac turpis egestas.
      </p>
    </div>`
        );
markdown.storyName = 'Markdown';
markdown.parameters = { storySource: { source: '`<div class=\"wp-block-jetpack-markdown\">\n      <p>\n        <b>Lorem</b> <i>ipsum</i> dolor sit amet, consectetur adipiscing elit. Quisque eu ex\n        enim. Nunc efficitur scelerisque dolor et sollicitudin.\n      </p>\n      <p>\n        Donec finibus lorem elit, eu consectetur quam pellentesque sed.\n        Pellentesque habitant morbi tristique senectus et netus et malesuada\n        fames ac turpis egestas.\n      </p>\n    </div>`' } };

const componentMeta = { title: 'Vendor/WordPress/Jetpack Blocks', includeStories: ["markdown"],  };

const mdxStoryNameToKey = {"Markdown":"markdown"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;